import React from 'react'
import "./ItsOverNineThousand.css"

const ItsOverNineThousand = ({ Over }) => {
  return (
    <h1 className='overhit' >
      {Over}
    </h1>
  )
}

export default ItsOverNineThousand
